var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{class:_vm.answerContainerClass},[_c('legend',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"options"},[_vm._l((_vm.dataSource),function(option){return [(_vm.inAnswer(option.id))?_c('p',{key:option.id},[_c('strong',[_vm._v(" "+_vm._s(option.value)+" ")])]):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }